var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8933 9.26621C28.04 6.37288 25.6266 3.95955 22.7333 3.10621C20.5333 2.46621 19.0133 2.51955 17.96 3.30621C16.6933 4.25288 16.5466 5.95955 16.5466 7.17288V10.4929C16.5466 13.7729 18.04 15.4395 20.9733 15.4395H24.8C26 15.4395 27.72 15.2929 28.6666 14.0262C29.48 12.9862 29.5466 11.4662 28.8933 9.26621Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M25.2133 17.8126C24.8667 17.4126 24.36 17.1859 23.84 17.1859H19.0667C16.72 17.1859 14.8133 15.2792 14.8133 12.9326V8.15922C14.8133 7.63922 14.5867 7.13256 14.1867 6.78589C13.8 6.43922 13.2667 6.27922 12.76 6.34589C9.62665 6.74589 6.74665 8.46589 4.86665 11.0526C2.97332 13.6526 2.27999 16.8259 2.87999 19.9992C3.74665 24.5859 7.41332 28.2526 12.0133 29.1192C12.7467 29.2659 13.48 29.3326 14.2133 29.3326C16.6267 29.3326 18.96 28.5859 20.9467 27.1326C23.5333 25.2526 25.2533 22.3726 25.6533 19.2392C25.72 18.7192 25.56 18.1992 25.2133 17.8126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.9e5636a51307010438061d0c935e44b2.svg";
export { ForwardRef as ReactComponent };